<template>
    <div class="container">
        <div class="row">
            <Menu class="col-lg-3"></Menu>
            <div class="col-lg-9">
                <b-card class="card">
                    <b-card-title>Уведомления</b-card-title>
                    <b-card-body>
                        <router-link :to="{ name: 'notifications-create' }">
                            <b-button variant="primary create-button">Создать уведомление</b-button>
                        </router-link>
                        <b-table
                                striped
                                hover
                                :busy="notificationsTable.isBusy"
                                :fields="notificationsTable.fields"
                                :items="notificationsTable.items"
                        >
                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Загрузка</strong>
                                </div>
                            </template>
                            <template v-slot:cell(actions)="data">
                                <b-icon-trash class="action-delete action" @click="onDeleteButton(data.value.id)"></b-icon-trash>
                            </template>
                        </b-table>
                        <b-pagination
                                align="right"
                                v-model="pagination.curPage"
                                :per-page="pagination.countOnPage"
                                :total-rows="pagination.totalRows"
                                @change="onPageChanged"
                                use-router
                        ></b-pagination>
                    </b-card-body>
                </b-card>

                <b-modal ref="err-modal" size="sm" hide-footer>
                    <div class="d-block text-center">
                        Ошибка сервера!
                    </div>
                    <b-button class="mt-3" variant="danger" block @click="closeModal">ОК</b-button>
                </b-modal>
                <b-modal ref="delete-modal" size="sm" hide-footer>
                    <div class="d-block text-center">
                        Вы действительно хотите удалить уведомление? Оно будет <strong>утеряно безвозвратно</strong>.
                    </div>
                    <br><br>
                    <b-button size="sm" block variant="danger" @click="submitDeleteModal">Удалить</b-button>
                    <b-button size="sm" block variant="light" @click="denyDeleteModal">Отмена</b-button>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import Menu from "../../common/Menu";
import moment from "moment";
export default {
    name: "Notifications",
    components: { Menu },
    data: () => ({
        notificationsTable: {
            fields: [
                {
                    key: 'title',
                    label: 'Заголовок'
                },
                {
                    key: 'content',
                    label: 'Содержание'
                },
                {
                    key: 'pubDate',
                    label: 'Дата публикации'
                },
                {
                    key: 'expDate',
                    label: 'Дата окончания'
                },
                {
                    key: 'actions',
                    label: 'Действия',
                    formatter: (meta) => ({
                        id: meta.id,
                    }),
                },
            ],
            items: [],
            isBusy: true,
        },
        pagination: {
            totalRows: 0,
            curPage: 1,
            countOnPage: 10,
        },
        currentId: 0,
    }),
    created() {
        this.loadTable();
        moment.locale('ru');
    },
    methods: {
        async fetchTable(pageNum) {
            await this.$http.post(`${process.env.VUE_APP_API_HOST}/notifications/admin`, {
                page: pageNum - 1,
                pageSize: this.pagination.countOnPage,
            }, {
                headers: {
                    Authorization: `JWT ${localStorage.getItem('jwt')}`
                },
            })
                    .then(result => {
                        this.notificationsTable.items = result.data.data.rows.map(item => ({
                            title: item.title,
                            pubDate: moment(item.pubDate).format('LL  HH:mm'),
                            expDate: item.expDate ? moment(item.expDate).format('LL  HH:mm') : '-',
                            content: item.content,
                            actions: { id: item.id },
                        }));
                        this.notificationsTable.isBusy = false;
                        this.pagination.totalRows = result.data.data.info.totalCount;
                    })
        },
        async loadTable(pageNum = 1) {
            this.notificationsTable.isBusy = true;
            this.notificationsTable.items = [];

            try {
                await this.fetchTable(pageNum);
                return;
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        await this.refreshAuth();
                    } else {
                        this.$refs['err-modal'].show();
                        return;
                    }
                }
            }

            try {
                await this.fetchTable(pageNum);
            } catch (error) {
                // Show connection error
                this.$refs['err-modal'].show();
            }
        },
        onPageChanged(pageNum) {
            if (pageNum === this.pagination.curPage) {
                return;
            }
            this.loadTable(pageNum)
        },
        async submitDeleteModal() {
            this.$refs['delete-modal'].hide();
            if (this.currentId) {
                try {
                    await this.$http.delete(`${process.env.VUE_APP_API_HOST}/notifications/${this.currentId}`, {
                        headers: {
                            Authorization: `JWT ${localStorage.getItem('jwt')}`
                        },
                    });
                    this.loadTable();
                    this.currentId = 0;
                    return;
                } catch (error) {
                    if (error.response) {
                        if (error.response.status === 401) {
                            await this.refreshAuth();
                        } else {
                            this.$refs['err-modal'].show();
                            return;
                        }
                    }
                }

                try {
                    await this.$http.delete(`${process.env.VUE_APP_API_HOST}/notifications/${this.currentId}`, {
                        headers: {
                            Authorization: `JWT ${localStorage.getItem('jwt')}`
                        },
                    });
                    this.loadTable();
                } catch (error) {
                    // Show connection error
                    this.$refs['err-modal'].show();
                }
                this.currentId = 0;
            }
        },
        onDeleteButton(id) {
            this.currentId = id;
            this.$refs['delete-modal'].show();
        },
        denyDeleteModal() {
            this.$refs['delete-modal'].hide();
            this.currentId = 0;
        },
        closeModal() {
            this.$refs['err-modal'].hide();
        },
    }
}
</script>

<style scoped>
.create-button {
    margin-bottom: 10px;
}

.action {
    cursor: pointer;
    font-size: 20px;
    margin-right: 5px;
}

.action-edit {
    color: #212529;
}

.action-edit:hover {
    transition-duration: .5s;
    color: #1f99db;
}

.action-delete:hover {
    transition-duration: .5s;
    color: #d9594e;
}
</style>